import type { LifeEvent } from '@/types';
import { AppChipButton } from '../../../ui-foundation/adapters/web';

const LIFE_EVENTS: LifeEvent[] = [
  'Changed job',
  'Moved house',
  'New baby',
  'Separated',
  "Child's birthday",
];

const EXTENDED_EVENTS = [
  ...LIFE_EVENTS,
  'Redundancy',
  'Bereavement',
  'New diagnosis',
] as const;

type ExtendedLifeEvent = (typeof EXTENDED_EVENTS)[number];

interface LifeEventsChipsProps {
  activeEvents: string[];
  onTap: (event: string) => void;
}

export default function LifeEventsChips({ activeEvents, onTap }: LifeEventsChipsProps) {
  return (
    <section>
      <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-3">
        Life events — tap to save and re-scan
      </h2>
      <p className="text-xs text-muted-foreground mb-3">
        Save anything relevant here so Adulting can rerun this benefits check with any safe assumptions it can make, then show you what still needs a manual update.
      </p>
      <div className="flex flex-wrap gap-2">
        {EXTENDED_EVENTS.map(event => (
          <AppChipButton
            key={event}
            onClick={() => onTap(event)}
            active={activeEvents.includes(event)}
          >
            {event}
          </AppChipButton>
        ))}
      </div>
    </section>
  );
}
